import EventBus from 'eventing-bus';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Menu } from '@mui/material';

import constants from '../../constants';
import BulkEditModal from './BulkEditModal';
import TagsManager from '../Tags/TagsManager';
import BulkAssignModal from './BulkAssignModal';
import { setActiveActivityBox } from '../../store/Activities';

const BulkActionsBar = ({ objectType, selectedItems, onClearSelection, onRefresh, onDelete, onVerifyEmails, totalItems, onSelectAll, customActions = [], allRecordsSelected = false, activeView = null, filters = null }) => {
  const dispatch = useDispatch();
  const isVerifying = useSelector(state => state['Objects']['verifyingEmails']);
  const [isBulkEditModalOpen, setIsBulkEditModalOpen] = useState(false);
  const [isBulkAssignModalOpen, setIsBulkAssignModalOpen] = useState(false);
  const objectSchema = constants.getObjectSchema(objectType);
  const [tagsManagerOpen, setTagsManagerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  if (!selectedItems || selectedItems.length === 0) {
    return <></>;
  }

  const itemCount = allRecordsSelected ? totalItems : selectedItems.length;
  const isAllSelected = allRecordsSelected || (totalItems && selectedItems.length === totalItems);

  // Handle bulk edit action
  const handleBulkEdit = () => {
    if (selectedItems.length > 0) setIsBulkEditModalOpen(true);
    else EventBus.publish('error', `Please select ${objectType}`);
  }

  // Handle bulk delete action
  const handleBulkDelete = () => {
    if (selectedItems.length > 0) {
      if (onDelete) {
        onDelete();
      } else EventBus.publish('error', 'Delete handler not provided');
    } else EventBus.publish('error', `Please select ${objectType}`);
  }

  // Handle create tasks action
  const handleCreateTasks = () => {
    if (selectedItems.length === 0) return EventBus.publish('error', `Please select ${objectType}`);
    const activityData = {
      activityBox: 'task',
      source: 'bulkActions',
      associations: { [objectSchema['plural']]: selectedItems },
    };
    dispatch(setActiveActivityBox(activityData));
  }

  // Handle bulk assign action
  const handleBulkAssign = () => {
    if (selectedItems.length === 0) return EventBus.publish('error', `Please select ${objectType}`);
    setIsBulkAssignModalOpen(true);
  }

  const handleVerifyEmails = () => {
    if (selectedItems.length === 0) return EventBus.publish('error', 'Please select contacts');
    if (onVerifyEmails) onVerifyEmails();
  };

  const handleOpenTagsManager = (event) => {
    setAnchorEl(event.currentTarget); // jis button pe click hua usi ko anchor bana diya
  };

  const handleCloseTagsManager = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <div className="table-container filters-table">
            <div className='header-table-filters advanced-table-filters style-filter-show'>
              <div className='left-area'>
                <p>
                  {itemCount} {objectSchema['label']} selected
                  {totalItems && !isAllSelected && onSelectAll && (
                    <>
                      {' '}
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          onSelectAll();
                        }}
                        style={{ color: 'var(--primary-color)', fontSize: '12px', position: 'relative', }}
                      >
                        Select all {totalItems} {objectSchema['plural'] || objectSchema['label'] + 's'}
                      </a>
                    </>
                  )}
                </p>

                {/* Assign Button */}
                <button className='assing-btn d-flex' onClick={handleBulkAssign} title="Assign">
                  <i className='icon'>
                    <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.00049 5L11.0672 2.93327L9.00049 0.866576" stroke="var(--primary-color)" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.06689 2.93359L11.0671 2.93359" stroke="var(--primary-color)" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </i>
                  <span className="btn-text">Assign</span>
                </button>

                {/* Edit Button */}
                <button className='assing-btn d-flex' onClick={handleBulkEdit} title="Edit">
                  <i className='icon'>
                    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.14459 1.64981L2.38167 5.63273C2.23959 5.78398 2.10209 6.0819 2.07459 6.28815L1.90501 7.77315C1.84542 8.3094 2.23042 8.67606 2.76209 8.5844L4.23792 8.33232C4.44417 8.29565 4.73292 8.1444 4.87501 7.98856L8.63792 4.00565C9.28876 3.31815 9.58209 2.5344 8.56917 1.57648C7.56084 0.627731 6.79542 0.962314 6.14459 1.64981Z" stroke="var(--primary-color)" strokeWidth="0.6875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5.5166 2.31445C5.71368 3.57945 6.74035 4.54654 8.01452 4.67487" stroke="var(--primary-color)" strokeWidth="0.6875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.44189 10.0835H9.69189" stroke="var(--primary-color)" strokeWidth="0.6875" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </i>
                  <span className="btn-text">Edit</span>
                </button>

                {/* Delete Button */}
                <button onClick={handleBulkDelete} className='assing-btn d-flex' title="Delete">
                  <i className='icon'>
                    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.69189 2.74089C8.16564 2.58964 6.63023 2.51172 5.09939 2.51172C4.19189 2.51172 3.28439 2.55755 2.37689 2.64922L1.44189 2.74089" stroke="#4B5563" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3.96289 2.27775L4.06372 1.67734C4.13706 1.24192 4.19206 0.916504 4.96664 0.916504H6.16747C6.94206 0.916504 7.00164 1.26025 7.07039 1.68192L7.17122 2.27775" stroke="#4B5563" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M8.70641 4.18945L8.4085 8.80487C8.35808 9.52445 8.31683 10.0836 7.03808 10.0836H4.09558C2.81683 10.0836 2.77558 9.52445 2.72516 8.80487L2.42725 4.18945" stroke="#4B5563" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M4.80176 7.5625H6.32801" stroke="#4B5563" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M4.4209 5.729H6.71257" stroke="#4B5563" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </i>
                  <span className="btn-text">Delete</span>
                </button>

                {/* Create Tasks Button */}
                <button className='assing-btn d-flex' onClick={handleCreateTasks} title="Create tasks">
                  <i className='icon'>
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.06689 5.5H10.0669" stroke="var(--primary-color)" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5.56689 10V1" stroke="var(--primary-color)" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </i>
                  <span className="btn-text">Create tasks</span>
                </button>

                {/* Verify Emails Button — contacts only */}
                {objectType === 'contacts' && (
                  <button className='assing-btn d-flex' onClick={handleVerifyEmails} disabled={isVerifying} title="Verify emails">
                    <i className='icon'>
                      <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.44189 2.2915H9.69189C10.1544 2.2915 10.5294 2.6665 10.5294 3.12484V8.12484C10.5294 8.58317 10.1544 8.95817 9.69189 8.95817H1.44189C0.979395 8.95817 0.604395 8.58317 0.604395 8.12484V3.12484C0.604395 2.6665 0.979395 2.2915 1.44189 2.2915Z" stroke="var(--primary-color)" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.5294 3.12484L5.56689 6.04151L0.604395 3.12484" stroke="var(--primary-color)" strokeWidth="0.6875" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </i>
                    <span className="btn-text">{isVerifying ? 'Verifying...' : 'Verify Emails'}</span>
                  </button>
                )}

                {/* Custom Actions */}
                {/* {customActions.map((action, index) => (
                  <button
                    key={index}
                    className='assing-btn d-flex'
                    onClick={action.onClick}
                  >
                    <i className='icon'>
                      {action.icon}
                    </i>
                    {action.label}
                  </button>
                ))} */}

                <button className='assing-btn d-flex' onClick={handleOpenTagsManager} title="Add tags">
                  <i className='icon'>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.0292 9.15828C4.4417 9.15828 3.85004 8.93328 3.4042 8.48745L1.5167 6.59995C1.05837 6.14162 0.816703 5.50828 0.84587 4.86245L0.94587 2.77912C0.991703 1.78328 1.7792 0.995784 2.7792 0.945784L4.86254 0.845784C5.50837 0.820784 6.1417 1.05828 6.60004 1.51662L8.48754 3.40412C9.38337 4.29995 9.38337 5.76245 8.48754 6.65828L6.65837 8.48745C6.20837 8.93328 5.62087 9.15828 5.0292 9.15828ZM1.95837 6.15412L3.84587 8.04162C4.16254 8.35828 4.58337 8.53328 5.0292 8.53328C5.47504 8.53328 5.89587 8.35828 6.21254 8.04162L8.0417 6.21245C8.35837 5.89578 8.53337 5.47495 8.53337 5.02912C8.53337 4.58328 8.35837 4.16245 8.0417 3.84578L6.1542 1.95828C5.82087 1.62495 5.35837 1.44578 4.8917 1.47078L2.80837 1.57078C2.1292 1.59995 1.60004 2.12912 1.5667 2.80412L1.4667 4.88745C1.44587 5.35828 1.62504 5.82078 1.95837 6.15412Z" fill="var(--primary-color)" />
                      <path d="M3.95829 5.31258C3.21246 5.31258 2.60413 4.70425 2.60413 3.95841C2.60413 3.21258 3.21246 2.60425 3.95829 2.60425C4.70413 2.60425 5.31246 3.21258 5.31246 3.95841C5.31246 4.70425 4.70413 5.31258 3.95829 5.31258ZM3.95829 3.22925C3.55829 3.22925 3.22913 3.55841 3.22913 3.95841C3.22913 4.35841 3.55829 4.68758 3.95829 4.68758C4.35829 4.68758 4.68746 4.35841 4.68746 3.95841C4.68746 3.55841 4.35829 3.22925 3.95829 3.22925Z" fill="var(--primary-color)" />
                    </svg>
                  </i>
                  <span className="btn-text">Add tags</span>
                </button>

                <Menu anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseTagsManager}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  slotProps={{
                    paper: { className: 'custom-dropdown-menu-tags' }
                  }}
                >
                  <TagsManager
                    objectType={objectType}
                    mode="select"
                    selectedObjects={selectedItems}
                    allRecordsSelected={allRecordsSelected}
                    totalCount={totalItems}
                    viewId={activeView?._id}
                    filters={filters}
                    onClose={handleCloseTagsManager}
                    onTagsApplied={() => {
                      setTagsManagerOpen(false);
                      // Refresh data
                      onRefresh();
                    }}
                  />
                </Menu>
              </div>

              {/* Close Button */}
              <div className='right-side-filter'>
                <button className='close' onClick={onClearSelection}>
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1_1030_1913" fill="white">
                      <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" />
                    </mask>
                    <path d="M8.21204 0.303865C8.6172 -0.100965 9.28744 -0.101115 9.69251 0.303865C10.0977 0.709019 10.0977 1.38016 9.69251 1.78531L6.47962 4.9982L9.69251 8.21109C10.0977 8.61625 10.0977 9.28738 9.69251 9.69254C9.48301 9.902 9.21762 10.0001 8.95227 10.0002C8.68695 10.0002 8.42155 9.9019 8.21204 9.69254L4.99817 6.47867L1.78528 9.69254C1.58981 9.90197 1.31035 10 1.04504 10.0002C0.779599 10.0002 0.513396 9.9021 0.303834 9.69254C-0.101246 9.28738 -0.101295 8.61622 0.303834 8.21109L3.51672 4.9982L0.303834 1.78531C-0.101299 1.38018 -0.101257 0.709025 0.303834 0.303865C0.708987 -0.101288 1.38013 -0.101288 1.78528 0.303865L4.99817 3.51676L8.21204 0.303865Z" fill="var(--primary-color)" />
                    <path d="M8.21204 0.303865L7.94019 0.0318008L7.94012 0.0318703L8.21204 0.303865ZM9.69251 0.303865L9.96446 0.0319116L9.96443 0.0318845L9.69251 0.303865ZM6.47962 4.9982L6.20766 4.72625L5.93571 4.9982L6.20766 5.27015L6.47962 4.9982ZM9.69251 9.69254L9.96444 9.96451L9.96446 9.96449L9.69251 9.69254ZM8.95227 10.0002V10.3848H8.95235L8.95227 10.0002ZM8.21204 9.69254L7.94008 9.96449L7.94018 9.96459L8.21204 9.69254ZM4.99817 6.47867L5.27012 6.20672L4.99813 5.93472L4.72617 6.20676L4.99817 6.47867ZM1.78528 9.69254L1.51312 9.42046L1.50411 9.43012L1.78528 9.69254ZM1.04504 10.0002V10.3848H1.04522L1.04504 10.0002ZM0.303834 9.69254L0.0318532 9.96446L0.0318803 9.96449L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L0.303834 8.21109ZM3.51672 4.9982L3.78868 5.27015L4.06063 4.9982L3.78868 4.72625L3.51672 4.9982ZM0.303834 0.303865L0.0318803 0.0319116L0.0318571 0.0319349L0.303834 0.303865ZM4.99817 3.51676L4.72622 3.78871L4.99813 4.06062L5.27008 3.78875L4.99817 3.51676ZM8.21204 0.303865L8.48388 0.575929C8.73895 0.321065 9.16579 0.321107 9.42058 0.575846L9.69251 0.303865L9.96443 0.0318845C9.4091 -0.523338 8.49544 -0.522995 7.94019 0.0318008L8.21204 0.303865ZM9.69251 0.303865L9.42055 0.575819C9.67551 0.830776 9.67551 1.2584 9.42055 1.51336L9.69251 1.78531L9.96446 2.05726C10.5198 1.50191 10.5198 0.587261 9.96446 0.0319116L9.69251 0.303865ZM9.69251 1.78531L9.42055 1.51336L6.20766 4.72625L6.47962 4.9982L6.75157 5.27015L9.96446 2.05726L9.69251 1.78531ZM6.47962 4.9982L6.20766 5.27015L9.42055 8.48305L9.69251 8.21109L9.96446 7.93914L6.75157 4.72625L6.47962 4.9982ZM9.69251 8.21109L9.42055 8.48305C9.67551 8.738 9.67551 9.16563 9.42055 9.42058L9.69251 9.69254L9.96446 9.96449C10.5198 9.40914 10.5198 8.49449 9.96446 7.93914L9.69251 8.21109ZM9.69251 9.69254L9.42057 9.42056C9.28679 9.55432 9.12078 9.61552 8.95219 9.61555L8.95227 10.0002L8.95235 10.3848C9.31445 10.3847 9.67923 10.2497 9.96444 9.96451L9.69251 9.69254ZM8.95227 10.0002V9.61555C8.7839 9.61555 8.61783 9.55432 8.48389 9.42048L8.21204 9.69254L7.94018 9.96459C8.22528 10.2495 8.58999 10.3848 8.95227 10.3848V10.0002ZM8.21204 9.69254L8.48399 9.42058L5.27012 6.20672L4.99817 6.47867L4.72622 6.75062L7.94008 9.96449L8.21204 9.69254ZM4.99817 6.47867L4.72617 6.20676L1.51328 9.42062L1.78528 9.69254L2.05727 9.96445L5.27016 6.75058L4.99817 6.47867ZM1.78528 9.69254L1.50411 9.43012C1.39292 9.54926 1.22188 9.61548 1.04487 9.61555L1.04504 10.0002L1.04522 10.3848C1.39881 10.3846 1.78669 10.2547 2.06644 9.95496L1.78528 9.69254ZM1.04504 10.0002V9.61555C0.876053 9.61555 0.709392 9.55419 0.575787 9.42058L0.303834 9.69254L0.0318803 9.96449C0.3174 10.25 0.683146 10.3848 1.04504 10.3848V10.0002ZM0.303834 9.69254L0.575814 9.42061C0.320867 9.16561 0.320881 8.73795 0.575787 8.48305L0.303834 8.21109L0.0318803 7.93914C-0.523471 8.49449 -0.52336 9.40914 0.0318532 9.96446L0.303834 9.69254ZM0.303834 8.21109L0.575787 8.48305L3.78868 5.27015L3.51672 4.9982L3.24477 4.72625L0.0318803 7.93914L0.303834 8.21109ZM3.51672 4.9982L3.78868 4.72625L0.575787 1.51336L0.303834 1.78531L0.0318803 2.05726L3.24477 5.27015L3.51672 4.9982ZM0.303834 1.78531L0.575787 1.51336C0.320873 1.25844 0.320862 0.830788 0.57581 0.575795L0.303834 0.303865L0.0318571 0.0319349C-0.523376 0.587263 -0.523471 1.50191 0.0318803 2.05726L0.303834 1.78531ZM0.303834 0.303865L0.575787 0.575819C0.830745 0.320861 1.25837 0.320861 1.51333 0.575819L1.78528 0.303865L2.05723 0.0319116C1.50188 -0.523438 0.58723 -0.523438 0.0318803 0.0319116L0.303834 0.303865ZM1.78528 0.303865L1.51333 0.575819L4.72622 3.78871L4.99817 3.51676L5.27012 3.2448L2.05723 0.0319116L1.78528 0.303865ZM4.99817 3.51676L5.27008 3.78875L8.48395 0.57586L8.21204 0.303865L7.94012 0.0318703L4.72626 3.24476L4.99817 3.51676Z" fill="white" mask="url(#path-1-inside-1_1030_1913)" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bulk Edit Modal */}
      <BulkEditModal
        objectSchema={objectSchema}
        isOpen={isBulkEditModalOpen}
        selectedIds={selectedItems}
        allRecordsSelected={allRecordsSelected}
        viewId={activeView?._id}
        onClearSelection={onClearSelection}
        onClose={() => setIsBulkEditModalOpen(false)}
        onRefresh={onRefresh}
      />

      {/* Bulk Assign Modal */}
      <BulkAssignModal
        objectSchema={objectSchema}
        isOpen={isBulkAssignModalOpen}
        selectedIds={selectedItems}
        allRecordsSelected={allRecordsSelected}
        totalCount={totalItems}
        viewId={activeView?._id}
        filters={filters}
        onClearSelection={onClearSelection}
        onClose={() => setIsBulkAssignModalOpen(false)}
        onRefresh={onRefresh}
      />
    </>
  );
};

export default BulkActionsBar;